// extracted by mini-css-extract-plugin
export default {"app":"App_app__6Ra7L","main":"App_main__g-ZH2"};